import 'regenerator-runtime'
import Sentry from '../../config/sentry'

const SAMPLE_RATE = 0.01

/**
 * Local Network Access 권한 관리 유틸리티 클래스
 */
export default class LNA {
  /**
   * Local Network Access 권한을 확인하고 필요시 사용자에게 안내
   * @param {number} maxRetries - 최대 재시도 횟수 (기본값: 60)
   * @param {number} currentRetry - 현재 재시도 횟수 (기본값: 0)
   * @returns {Promise<boolean>} 권한 허용 여부
   */
  static async checkLNAPermission(maxRetries = 60, currentRetry = 0) {
    try {
      // Local Network Access API를 지원하지 않는 브라우저는 true 반환
      if (!navigator.permissions || typeof navigator.permissions.query !== 'function') {
        console.warn('[checkLNAPermission] Local Network Access API not supported')
        return true
      }

      const result = await navigator.permissions.query({ name: 'local-network-access' })

      switch (result.state) {
        case 'granted':
          console.log('[checkLNAPermission] Local network access granted')
          return true

        case 'denied':
          console.warn('[checkLNAPermission] Local network access denied')
          await window.$globalModal.warning({ message: window.$i18next.t('LOCAL_NETWORK_ACCESS_DENIED') })

          // 얼럿 확인 시 재시도
          if (currentRetry < maxRetries) {
            return LNA.checkLNAPermission(maxRetries, currentRetry + 1)
          }

          Sentry.withScope((scope) => {
            scope.setLevel('warning')
            scope.setExtra('retryCount', currentRetry)
            Sentry.captureMessage('[checkLNAPermission] Local network access denied after retries')
          })
          return false

        case 'prompt':
          console.log('[checkLNAPermission] Local network access requires user permission')
          window.$globalModal.warning({ message: window.$i18next.t('LOCAL_NETWORK_ACCESS_PROMPT') })

          if (Math.random() < SAMPLE_RATE) {
            Sentry.withScope((scope) => {
              scope.setLevel('warning')
              scope.setTag('sample_rate', `${SAMPLE_RATE * 100}%`)
              Sentry.captureMessage('[checkLNAPermission] Local network access prompt not resolved')
            })
          }

          return false

        default:
          console.warn('[checkLNAPermission] Unknown permission state:', result.state)
          return false
      }
    } catch (error) {
      console.error('[checkLNAPermission] Error checking local network access permission:', error)

      if (Math.random() < SAMPLE_RATE) {
        Sentry.withScope((scope) => {
          scope.setLevel('error')
          scope.setExtra('error', error.message)
          scope.setExtra('retryCount', currentRetry)
          scope.setTag('sample_rate', `${SAMPLE_RATE * 100}%`)
          Sentry.captureException(error)
        })
      }

      // 에러 발생 시 기본적으로 true 반환 (기능 차단하지 않음)
      return true
    }
  }
}
